module.exports = __webpack_public_path__ + "static/media/nba_logo.df42eb5d.jpg";